export default __webpack_public_path__ + "static/media/wind.76ccb8e1.png";